import React, { useEffect } from 'react'
import { S3_URL } from '../../../utils/BaseUrl'
import Spinwheel from '../Spinwheel'
import Select from 'react-select';
import DatePicker from 'react-datepicker'
import { getAddressSuggestionsApi } from '../../../utils/ApiEndpointFunctions';
import { debounce } from 'lodash';
import AsyncSelect from 'react-select/async';
import PhoneInput from 'react-phone-input-2';
import moment from 'moment';
function AddOrUpdateDetails({ formik, addLoader, modalId, dataFormat = [], detailsFor }) {

  const fetchAddressSuggestion = async (inputValue, cb) => {
    try {
      const res = await getAddressSuggestionsApi(inputValue)
      if (res.status === 200) {
        let options = res.data?.data?.map(ele => ({ label: ele.name, value: ele }))
        cb(options);
      }
    } catch (error) {
      console.log(error)
    }
  };

  const addressOnChange = debounce(fetchAddressSuggestion, 1000);

  const addressOptions = (inputValue, callback) => {
    addressOnChange(inputValue, callback);
  }

  useEffect(() => {
    console.log("valuess ", JSON.stringify(formik?.values, null, 2))
    console.log("errors ", JSON.stringify(formik?.errors, null, 2))
  }, [formik?.values, formik?.errors])

  return (
    <>
      <div
        className="modal fade"
        id={modalId}
        tabIndex="-1"
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog  modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                id="confirmModalCloseBtn"
                type="button"
                className="btn-close block-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body pe-0 ps-0">
              <div className="container">
                <h2> {formik?.values?.id ? "Update" : "Add"} {detailsFor}</h2>
                <form onSubmit={formik?.handleSubmit} >
                  {dataFormat?.map(ele => {
                    if (ele?.type == "input") {
                      return <div className="mb-3" key={ele?.name}>
                        <label htmlFor={ele?.name} className="form-label">{ele?.label}</label>
                        <input
                          type="text"
                          className="form-control"
                          id={ele?.name}
                          placeholder="Enter description"
                          name={ele?.name}
                          value={formik?.values?.[ele?.name]}
                          onChange={(e) => ele?.handleOnChange(ele?.name, e, formik, "input")}
                          onBlur={formik?.handleBlur}
                        />
                        {formik?.touched?.[ele?.name] && formik?.errors?.[ele?.name] ? (
                          <div className='req-error'>{formik?.errors?.[ele?.name]}</div>
                        ) : null}
                      </div>
                    } else if (ele?.type == "select") {
                      return <div className="mb-3" key={ele?.name}>
                        <label htmlFor={ele?.name} className="form-label">{ele?.label}</label>
                        <Select
                          id={ele?.name}
                          name={ele?.name}
                          options={ele?.options || []}
                          value={formik.values?.[ele?.name]}
                          onChange={(selectedOption) => ele?.handleOnChange(ele?.name, selectedOption, formik, "select")}
                          onBlur={() => formik.setFieldTouched(ele?.name, true)}
                        />
                        {formik.touched?.[ele?.name] && formik.errors?.[ele?.name] ? (
                          <div className='req-error'>{formik.errors?.[ele?.name]}</div>
                        ) : null}
                      </div>
                    } else if (ele?.type == "multi-select") {
                      return <div className="mb-3" key={ele?.name}>
                        <label htmlFor={ele?.name} className="form-label">{ele?.label}</label>
                        <Select
                          id={ele?.name}
                          name={ele?.name}
                          options={ele?.options || []}
                          value={formik.values?.[ele?.name]}
                          onChange={(selectedOption) => ele?.handleOnChange(ele?.name, selectedOption, formik, "select")}
                          onBlur={() => formik.setFieldTouched(ele?.name, true)}
                          isMulti
                        />
                        {formik.touched?.[ele?.name] && formik.errors?.[ele?.name] ? (
                          <div className='req-error'>{formik.errors?.[ele?.name]}</div>
                        ) : null}
                      </div>
                    } else if (ele?.type == "file") {
                      return <div className="mb-3" key={ele?.name}>
                        <label htmlFor={ele?.name} className="form-label">{ele?.label}</label>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="position-relative">
                            {<img
                              src={formik?.values?.[ele?.name] ? `${S3_URL}/${formik?.values?.[ele?.name]}` : "/images/image.svg"}
                              width="70px"
                              height="50px"
                              style={{ objectFit: "contain" }}
                              className="rounnded"
                              alt="Selected file"
                            />}
                            {formik?.values?.type === "video" &&
                              <>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-camera pro-camera" viewBox="0 0 16 16">
                                  <path d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1v6zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z" />
                                  <path d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" />
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x xmark" viewBox="0 0 16 16" onClick={() => { formik.setFieldValue(ele?.name, "undefined/image.svg") }} >
                                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                </svg>
                              </>
                            }
                          </div>
                          <div className="btn_upload">
                            <input
                              type="file"
                              id={ele?.name}
                              disabled={ele?.loading}
                              className="form-control"
                              name={ele?.name}
                              accept={ele?.acceptFiles}
                              onChange={(e) => ele?.handleFileUpload(ele?.name, e, formik)}
                            />
                            {ele?.loading ? <Spinwheel /> : ele?.btnText || "Upload"}
                          </div>
                        </div>
                        {formik?.touched?.[ele?.name] && formik?.errors?.[ele?.name] ? (
                          <div className='req-error'>{formik?.errors?.[ele?.name]}</div>
                        ) : null}
                      </div>
                    } else if (ele?.type === "date") {
                      return <div className='d-flex flex-column mb-3 w-100' key={ele?.name}>
                        <label htmlFor={ele.name} className=" col-form-label">{ele.label}</label>
                        <div className="w-100">
                          <DatePicker
                            className='form-control w-100'
                            name={ele.name}
                            dateFormat={"dd/MM/yyyy"}
                            placeholderText='dd/MM/yyyy'
                            selected={formik.values?.[ele.name] ? new Date(formik.values?.[ele.name]) : null}
                            onChange={(date) => ele?.handleOnChange(ele?.name, date, formik, "date")}
                            maxDate={ele?.max && formik.values?.[ele?.max] ? new Date(formik.values[ele?.max]) : undefined}
                            minDate={ele?.min && formik.values?.[ele?.min] ? new Date(formik.values[ele?.min]) : undefined}
                          />
                          {formik?.touched?.[ele.name] && formik.errors?.[ele.name] ? (
                            <div className='req-error'>{formik?.errors?.[ele.name]}</div>
                          ) : null}
                        </div>
                      </div>
                    } else if (ele?.type === "time") {
                      return <div className='d-flex flex-column mb-3 w-100' key={ele?.name}>
                        <label htmlFor={ele.name} className="col-form-label">{ele.label}</label>
                        <div className="w-100">
                          <DatePicker
                            className='form-control w-100'
                            name={ele.name}
                            selected={formik.values?.[ele.name] ? moment(formik.values?.[ele.name], "h:mm A").toDate() : null}
                            onChange={(time) => {
                              const formatted = moment(time).format("h:mm A"); // ✅ Store formatted time
                              ele?.handleOnChange(ele?.name, formatted, formik, "time");
                            }}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption="Time"
                            dateFormat="h:mm aa" // ✅ 12-hour AM/PM format
                            placeholderText="hh:mm AM/PM"
                          />
                          {formik?.touched?.[ele.name] && formik.errors?.[ele.name] ? (
                            <div className='req-error'>{formik?.errors?.[ele.name]}</div>
                          ) : null}
                        </div>
                      </div>
                    } else if (ele?.type === "address") {
                      return <div className="d-flex flex-column mb-3 w-100" key={ele?.name}>
                        <label htmlFor={ele.name} className="form-label">{ele.label}</label>
                        <AsyncSelect
                          cacheOptions
                          loadOptions={addressOptions}
                          defaultOptions
                          value={formik?.values?.[ele?.name] ? { label: formik?.values?.[ele?.name] } : null}
                          onChange={(selectionOption) => ele?.handleOnChange(ele?.name, selectionOption, formik, "address")}
                          onBlur={formik?.handleBlur}
                        />
                        {formik?.touched?.[ele?.name] && formik?.errors?.[ele?.name] ? (
                          <div className='req-error'>{formik?.errors?.[ele?.name]}</div>
                        ) : null}
                      </div>
                    } else if (ele?.type === "toggle") {
                      return (
                        <div className="form-check form-switch mb-3" key={ele?.name}>
                          <label className="form-check-label me-2" htmlFor={ele?.name}>
                            {ele?.label}
                          </label>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={ele?.name}
                            name={ele?.name}
                            checked={Boolean(formik.values?.[ele?.name])}
                            onChange={(e) => ele?.handleOnChange(ele?.name, e.target.checked, formik, "toggle")}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched?.[ele?.name] && formik.errors?.[ele?.name] ? (
                            <div className='req-error'>{formik.errors?.[ele?.name]}</div>
                          ) : null}
                        </div>
                      );
                    } else if (ele?.type === "phone") {
                      return (
                        <div className="mb-3" key={ele?.name}>
                          <label htmlFor={ele?.name} className="form-label">{ele?.label}</label>
                          <PhoneInput
                            country={"ng"}
                            enableSearch={true}
                            value={formik.values?.[ele?.name] || ""}
                            onChange={(value) => {
                              const phoneValue = value.startsWith("+") ? value : `+${value}`;
                              ele?.handleOnChange(ele?.name, phoneValue, formik, "phone");
                            }}
                            onBlur={() => formik.setFieldTouched(ele?.name, true)}
                            inputClass="form-control w-100 customlogininput"
                            containerClass="w-100 border border-1"
                            buttonClass="border-right-0"
                          />
                          {formik.touched?.[ele?.name] && formik.errors?.[ele?.name] ? (
                            <div className="req-error">{formik.errors?.[ele?.name]}</div>
                          ) : null}
                        </div>
                      )
                    }
                  })}



                  <button type="submit" disabled={addLoader} className="btn btn-primary">
                    {addLoader ? <Spinwheel sizeClass={"spin-small"} /> : "Submit"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddOrUpdateDetails